// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UEP_GX {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacing-1);
  width: 100%;
  max-width: var(--carousel-max-width, 544px);
  font-family: var(--font-family-base);
}

.SCr719 {
  width: var(--carousel-max-width, 544px);
  height: var(--carousel-height, 244px);
  border-radius: var(--carousel-border-radius, var(--radius-xs));
  box-shadow: var(--carousel-box-shadow, var(--card-box-shadow));
  overflow: hidden;
  position: relative;
}

.G_Ciet {
  width: 100%;
  height: var(--carousel-height, 244px);
  position: relative;
}

.UCILZ3 {
  width: 100%;
  height: 100%;
  position: relative;
}

.touzmB {
  width: 100%;
  height: 100%;
  position: relative;
  transition: opacity 0.2s ease;
  /* Reset button styles */
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.touzmB:hover {
  opacity: 0.9;
}

.touzmB:focus {
  outline: 2px solid var(--carousel-focus-color, #007bff);
  outline-offset: 2px;
}

.Sr95vi {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--carousel-border-radius, var(--radius-xs));
}

.SCr719 .UpMXcB,
.SCr719 .GZnS5L {
  display: none;
}

.SCr719 .J_C2Ec {
  display: none;
}

.jGxmWd {
  position: absolute;
  bottom: var(--carousel-pagination-bottom, var(--spacing-3));
  right: var(--carousel-pagination-right, var(--spacing-3));
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: var(--carousel-pagination-gap, 4px);
  z-index: 10;
}

.hGapK_ {
  height: var(--carousel-pagination-dot-height, 4px);
  border-radius: var(--carousel-pagination-dot-border-radius, 999px);
  background-color: var(--carousel-pagination-inactive, rgba(255, 255, 255, 0.6));
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.hGapK_:not(.DwJDpB) {
  width: var(--carousel-pagination-dot-inactive-width, 10px);
}

.hGapK_.DwJDpB {
  width: var(--carousel-pagination-dot-active-width, 30px);
  background-color: var(--carousel-pagination-inactive, rgba(255, 255, 255, 0.6));
}

@media (max-width: 768px) {
  .SCr719 {
    width: 100%;
    max-width: var(--carousel-max-width, 544px);
  }

  .UEP_GX {
    max-width: 100%;
  }

  .jGxmWd {
    bottom: var(--spacing-2);
    right: var(--spacing-2);
  }
}

.SCr719 .E51H4v {
  transition: transform 0.6s ease-in-out;
}

.hGapK_:focus {
  outline: 2px solid var(--carousel-text-color, var(--surface-neutral-white));
  outline-offset: 2px;
}

.ChLkLG {
  aspect-ratio: 544 / 244;
  object-fit: fill;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Carousel/Carousel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,8DAA8D;EAC9D,8DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uDAAuD;EACvD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8DAA8D;AAChE;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,2DAA2D;EAC3D,yDAAyD;EACzD,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,kDAAkD;EAClD,kEAAkE;EAClE,+EAA+E;EAC/E,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,wDAAwD;EACxD,+EAA+E;AACjF;;AAEA;EACE;IACE,WAAW;IACX,2CAA2C;EAC7C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2EAA2E;EAC3E,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".carouselContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--spacing-1);\n  width: 100%;\n  max-width: var(--carousel-max-width, 544px);\n  font-family: var(--font-family-base);\n}\n\n.carousel {\n  width: var(--carousel-max-width, 544px);\n  height: var(--carousel-height, 244px);\n  border-radius: var(--carousel-border-radius, var(--radius-xs));\n  box-shadow: var(--carousel-box-shadow, var(--card-box-shadow));\n  overflow: hidden;\n  position: relative;\n}\n\n.carouselItem {\n  width: 100%;\n  height: var(--carousel-height, 244px);\n  position: relative;\n}\n\n.carouselWrapper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.carouselClickableWrapper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition: opacity 0.2s ease;\n  /* Reset button styles */\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.carouselClickableWrapper:hover {\n  opacity: 0.9;\n}\n\n.carouselClickableWrapper:focus {\n  outline: 2px solid var(--carousel-focus-color, #007bff);\n  outline-offset: 2px;\n}\n\n.carouselImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: var(--carousel-border-radius, var(--radius-xs));\n}\n\n.carousel .carousel-control-prev,\n.carousel .carousel-control-next {\n  display: none;\n}\n\n.carousel .carousel-indicators {\n  display: none;\n}\n\n.customPagination {\n  position: absolute;\n  bottom: var(--carousel-pagination-bottom, var(--spacing-3));\n  right: var(--carousel-pagination-right, var(--spacing-3));\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  gap: var(--carousel-pagination-gap, 4px);\n  z-index: 10;\n}\n\n.paginationDot {\n  height: var(--carousel-pagination-dot-height, 4px);\n  border-radius: var(--carousel-pagination-dot-border-radius, 999px);\n  background-color: var(--carousel-pagination-inactive, rgba(255, 255, 255, 0.6));\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.paginationDot:not(.active) {\n  width: var(--carousel-pagination-dot-inactive-width, 10px);\n}\n\n.paginationDot.active {\n  width: var(--carousel-pagination-dot-active-width, 30px);\n  background-color: var(--carousel-pagination-inactive, rgba(255, 255, 255, 0.6));\n}\n\n@media (max-width: 768px) {\n  .carousel {\n    width: 100%;\n    max-width: var(--carousel-max-width, 544px);\n  }\n\n  .carouselContainer {\n    max-width: 100%;\n  }\n\n  .customPagination {\n    bottom: var(--spacing-2);\n    right: var(--spacing-2);\n  }\n}\n\n.carousel .carousel-item {\n  transition: transform 0.6s ease-in-out;\n}\n\n.paginationDot:focus {\n  outline: 2px solid var(--carousel-text-color, var(--surface-neutral-white));\n  outline-offset: 2px;\n}\n\n.fittedImage {\n  aspect-ratio: 544 / 244;\n  object-fit: fill;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselContainer": `UEP_GX`,
	"carousel": `SCr719`,
	"carouselItem": `G_Ciet`,
	"carouselWrapper": `UCILZ3`,
	"carouselClickableWrapper": `touzmB`,
	"carouselImage": `Sr95vi`,
	"carousel-control-prev": `UpMXcB`,
	"carouselControlPrev": `UpMXcB`,
	"carousel-control-next": `GZnS5L`,
	"carouselControlNext": `GZnS5L`,
	"carousel-indicators": `J_C2Ec`,
	"carouselIndicators": `J_C2Ec`,
	"customPagination": `jGxmWd`,
	"paginationDot": `hGapK_`,
	"active": `DwJDpB`,
	"carousel-item": `E51H4v`,
	"carouselItem": `E51H4v`,
	"fittedImage": `ChLkLG`
};
module.exports = ___CSS_LOADER_EXPORT___;
